import { React, useState } from "react";
import styles from "./login.module.css";
import logo from "./logo.png";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ModalComp from "../../../components/popUp/ModalComp";
import SettingsChangePassword from "../../../components/settingsChangePassword/SettingsChangePassword";

const apiUrl = process.env.REACT_APP_URL;

const LoginPage = () => {
  /* The Login Page is a public page that allows the user to enter a username and password to login. The entered information is checked against the database, and if the credentials are valid, the user is redirected to his / her authenticaed home page (feed). Otherwise, an error message is shown. */

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [feedback, setFeedback] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility
  const navigate = useNavigate();

  /**
   * Handle change in one of the form input fields
   */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setFeedback(""); // Reset feedback when user starts typing
  };

  /**
   * Handle submission of the login form
   */
  async function handleLoginSubmit(e) {
    e.preventDefault();
    try {
      const res = await axios.post(`${apiUrl}/auth/login`, formData, {
        withCredentials: true,
      });

      if (res.status === 200 && res.data.success) {
        navigate("/home");
      } else {
        setFeedback("Invalid username and / or password.");
      }
    } catch (error) {
      console.error("Login error:", error.response);
      if (error.response) {
        if (error.response.status === 403) {
          if (error.response.data.message === "blocked") {
            setFeedback("Your account is blocked.");
          } else if (error.response.data.message === "inactive") {
            setFeedback("Your account is inactive.");
          } else if (
            error.response.data.message ===
            "Password expired. Please reset your password."
          ) {
            setFeedback("Your password has expired.");
          } else {
            setFeedback("Access forbidden.");
          }
        } else {
          setFeedback("Invalid username and / or password.");
        }
      } else {
        setFeedback("An error occurred. Please try again later.");
      }
    }
  }
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFormData({
      username: "",
      password: "",
    });
    setFeedback("");
  };

  return (
    <main className={styles.main}>
      <div className={styles.form}>
        <form onSubmit={handleLoginSubmit}>
          <figure className={styles.logoFig}>
            <img src={logo} alt="Logo" />
          </figure>
          {/* Username input */}
          <div className={styles.inputContainer}>
            <input
              type="text"
              name="username"
              placeholder="Username"
              className={styles.inputWithIcon}
              onChange={handleChange}
              value={formData.username}
              required
            />
          </div>
          {/* Password input */}
          <div className={styles.inputContainer}>
            <input
              type="password"
              name="password"
              placeholder="Password"
              className={styles.inputWithIcon}
              onChange={handleChange}
              value={formData.password}
              required
            />
          </div>

          <button className={styles.loginBtn} type="submit">
            Login
          </button>
        </form>
        {feedback && <span className={styles.feedbackContent}>{feedback}</span>}
        {feedback === "Your password has expired." && (
          <span
            className={styles.customLink}
            onClick={() => setIsModalOpen(true)}
          >
            Reset Password
          </span>
        )}
        <p className={styles.forgotPass}>
          <Link to="/passwordRecovery" className={styles.customLink}>
            Forgot Password?
          </Link>
        </p>
        <div className={styles.changeMode}>
          <Link to="/register" className={styles.customLink}>
            Sign up
          </Link>
        </div>
      </div>
      {/* Modal for resetting password */}
      <ModalComp isOpen={isModalOpen} onClose={handleCloseModal}>
        <SettingsChangePassword currUsername={formData.username} />
      </ModalComp>
    </main>
  );
};

export default LoginPage;
